<mat-card class="filter settingHeader">
  <div class="name">
    Manage Sub Types
  </div>
  <div class="quickAction">
    
      <mat-form-field appearance="">
        <mat-label>Search items in sub types</mat-label>
        <input matInput type="text" [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
        <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>close</mat-icon>
        </button>
        <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
          <mat-icon>search</mat-icon>
        </button>
      </mat-form-field>

  </div>
</mat-card>

<div class="documents">

    <mat-card class="example-list rowholder" *ngIf="!ShowNoRecordFound">
      <div class="fieldRow head">
        <span class="moveicon"></span>
        <span class="fieldName">SubType</span>
        <span class="fieldName">Type</span>
        <span class="requried">Active/Inactive</span>
        <span class="editField">Edit</span>
        <span class="delete">Delete</span>
      </div>
      <div class="example-box fieldRow" *ngFor="let type of typeListActive">
        <span class="moveicon"></span>
  
        <span class="fieldName">{{type.subFolderName}}</span>
        <span class="fieldName">{{type.orgModuleName}}</span>
  
        <span class="requried">
          <mat-slide-toggle color="primary"  [checked]="type.isActive" (change)="UpdateType(type,$event)">
          </mat-slide-toggle>
        </span>
  
  
        <span class="editField">
          <button mat-icon-button class="editbtn" (click)="openDialogWithRef(myDialog,type)" >
            <mat-icon>edit</mat-icon>
          </button>
        </span>
  
        <span class="delete">
          <button mat-icon-button class="trash" (click)="checkIfTypeExists(type)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </span>
      </div>
      <mat-paginator [pageIndex]="pageIndex" [pageSize]="pageSize" [length]="paginatorTotalLength" [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons  (page)="CallNextPrevPageData($event)"></mat-paginator>
         
    </mat-card>
    <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>

</div>


<ng-template #myDialog>
  <form  [formGroup]="formDialog">
  <h2 mat-dialog-title>
      Edit Subtype
      <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
      </button>
  </h2>
  
<mat-dialog-content class="mat-typography">
  <mat-form-field class="example-full-width">
      <mat-label>Subtype</mat-label>
      <input matInput maxlength="30" [required]="true"  placeholder="Edit Subtype" formControlName="subtype" [(ngModel)]="editType.folderName" />
      <mat-error
      *ngIf="formDialog.get('subtype').invalid &&
        (formDialog.get('subtype').dirty ||
        formDialog.get('subtype').touched)">
      <span>This field is mandatory.</span>
    </mat-error>
    </mat-form-field>

  <mat-slide-toggle color="primary" formControlName="active" [(ngModel)]="editType.isActive"> </mat-slide-toggle>

</mat-dialog-content>

<mat-dialog-actions class="dialog-actions"  >
  <button mat-button (click)="close()">Cancel</button>
  <button mat-flat-button color="primary" 
  [disabled]="formDialog.invalid || !formDialog.dirty"   
  (click)="UpdateTypeDetails()">
    Update
    <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
    </mat-spinner></mat-icon>
  </button>
</mat-dialog-actions>
<app-loader></app-loader>
</form>
</ng-template>

<app-loader></app-loader>